<div class="component-wrapper">
  @if (label !== '') {
    <div id="label" [class.noTopPadding]="noTopPaddingForLabel">
      @if (hasValidtor('require')) {
        <span class="reqIcon" id="require" #require > * </span>
      }
      <span>{{label}}</span>
      @if (hasValidtor('info')) {
        <mat-icon id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info'}"
          class="infoIcon" svgIcon="help.tooltip">
        </mat-icon>
      }
    </div>
  }


  <div class="dropdownWrapper" (insClickOutside)="dropDownOpened = false" [insCloseListOnScroll]="dropDownOpened" (insListClosedOnScroll)="dropDownOpened = false">
    <div class="selectedRow" #selectedRow  [class.filled]="value !== ''" [class.listOpened]="dropDownOpened" [class.disabled]="disabled" insTooltip [cfg]="getToolTipConf(descDiv,getDisplayValue())" (click)="toggleDropDown(selectedRow, $event)">
      <div class="zoneName" #descDiv >{{getDisplayValue()}}</div>
      <mat-icon svgIcon={{getIconName()}} class="expandIcon"></mat-icon>
    </div>
    <div #resultsList [class.opened]="dropDownOpened" class="valuesList" [style.width.px]="calculatedWidth" [style.top.px]="calculatedTopForList">
      <div #innerResultsList class="valuesListContent" [style.max-height.px]="calculatedMaxHeight">
        @for (option of options; track option) {
          <div class="row" (click)="selectValue(option)" [class.active]="option.value === value">
            <div class="zoneName">{{option.displayValue}}<div>
            </div>
          </div>
        </div>
      }
    </div>


  </div>
